import { Form, Table, Modal } from 'antd';
import { MasterDataSelector } from '../../store/reducers/masterData/masterData'
import React, { useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { ConstContext } from '../../store/context/constContext'
import { DocumentMasterDataSelector, getItemDocument } from '../../store/reducers/document/documentMasterData'

const ItemMasterData = () => {
      // Contexts
  const {
    showItemMasterData,
    setShowItemMasterData
  } = useContext(ConstContext)
    const dispatch = useDispatch()
    const MasterDataSelectors = useSelector(MasterDataSelector)
    const DocumentMasterDataSelectors = useSelector(DocumentMasterDataSelector)
    const [form] = Form.useForm();
    const columns = [
        {
            title: 'Mã hàng',
            dataIndex: 'ItemCode',
            key: 'ItemCode',
            fixed: 'left',
            width: 150,
        },
        {
            title: 'Tên hàng',
            dataIndex: 'ItemName',
            key: 'ItemName',
        },
        {
            title: 'Chọn',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (_, record) => <a onClick={() => (onClickSelectItem(record.ItemCode.toString()))}>Chọn</a>,
          }
    ]
    const onClosed = () => {
        setShowItemMasterData(false)
    }
    const onClickSelectItem = (itemCode) =>
    {
        dispatch(getItemDocument())
        setShowItemMasterData(false)
    }
    return (
        <>
            <Modal
                title="Chọn hàng hóa"
                centered
                visible={showItemMasterData}
                onOk={() => onClosed()}
                onCancel={() => onClosed()}
                width={1000}
            >
                <Table columns={columns} dataSource={MasterDataSelectors.itemMasterData} scroll={{ x: 1500, y: 300 }} rowKey="ItemCode"/>

            </Modal>

        </>
    )
}

export default ItemMasterData